import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonLabel,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import TopLeftUserName from "../components/TopLeftUserName";
import ExerciseSlider from "../components/ExerciseSlider";
import {
  allExercisesState,
  fixedAllExercisesState,
  isDuplicateCalledState,
  networkConnectionStatus,
  PatientState,
  // reviewPageListOfExercisesState,
} from "../data/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import { GetRecommendedExercises } from "../services/ExercisesService";
import { useHistory } from "react-router-dom";
import { ActionType } from "../models/Enums";
import { useEffect, useRef, useState } from "react";
import ExerciseCard from "../components/ExerciseCard";
import { localDateTime, sortTests } from "../utils/sharedFunction";
import Loader from "../components/LoaderComponent";
import { format } from "date-fns";
import ConsentFormModal from "../components/modals/consent-form-modal";
import ChooseEpisodeModal from "../components/modals/choose-episode-modal";
import NewEpisodeModal from "../components/modals/new-episode-modal";
import { PatientVM } from "../models/PatientVM";
import CompletedEducationModal from "../components/modals/completed-education-modal";
import RemoteTherapeuticMonitoringModal from "../components/modals/remote-therapeutic-monitoring-modal";
import RtmEnabledModal from "../components/modals/rtm-enabled-modal";
import { EnableDisablePatientRtm } from "../services/AuthServices";
import SetupEpisodeModal from "../components/modals/setup-episode-modal";
import ProactiveYouModal from "../components/modals/ProactiveYouModal";
import PatientRegistrationQRModal from "../components/modals/patient-registeration-qr-modal";
import ErrorTopToaster from "../components/ErrorTopToaster";

interface Props {
  patientInfo: any;
}

const FullVisitSummary: React.FC<Props> = ({ patientInfo }) => {
  let history = useHistory();

  const [exeCount, setExeCount] = useState(0);

  const [buttonsFooter, showButtonsFooter] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [allExercises, setAllExercisesState] =
    useRecoilState(allExercisesState);
  const [fixedExercisesCount, setFixedExercisesCount] = useRecoilState(
    fixedAllExercisesState,
  );
  const [previousExercises, setPreviousExercises] = useState<any>();
  const [isDuplicateCalled, setIsDuplicateCalled] = useRecoilState(
    isDuplicateCalledState,
  );
  const [isLoading, setIsLoading] = useState(false);
  // const reviewExercises = useRecoilValue(reviewPageListOfExercisesState);
  //Patient Details
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);
  const [CompletedEducation, setCompletedEducation] = useState(false);

  const [ConsentForm, setConsentForm] = useState(false);
  const [ChooseEpisode, setChooseEpisode] = useState(false);
  const [NewEpisode, setNewEpisode] = useState(false);
  const [SetupEpisode, setSetupEpisode] = useState(false);
  const [consentFormData, setConsentFormData] = useState<any>(null);
  // RTM State
  const [IsNewEpisode, setIsNewEpisode] = useState(false);
  const [IsRtmReenable, setIsRtmReenable] = useState(false);
  const [RtmEnabled, setRtmEnabled] = useState(false);
  const [openRtmModal, setOpenRtmModal] = useState(false);
  const [RemoteTherapeuticMonitoring, setRemoteTherapeuticMonitoring] =
    useState(false);
  const [isRtmConfigurationEnabled, setIsRtmConfigurationEnabled] =
    useState(false);
  const rtmEnabledRef = useRef(false);

  //const [excercisePlan, setExcercisePlan] = useState(false);

  // For Displaying the Exercise Not Created Modal
  const [ExerciseNotCreated, setExerciseNotCreated] = useState(false);

  // For Displaying the Disable RTM Modal
  const [showDisableRtmModal, setShowDisableRtmModal] = useState(false);
  const [openProactiveAfterClose, setOpenProactiveAfterClose] = useState(false);
  const [proactiveYouModal, setProactiveYouModal] = useState(false);

  const [registerPatientModal, setRegisterPatientModal] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    console.log("patientDetailsRecoil", patientDetailsRecoil);
    const saved = sessionStorage.getItem("patientDetails");
    if (patientDetailsRecoil?.id === -1) {
      setPatientDetails(JSON.parse(saved!));
      setPatientDetailsRecoil(JSON.parse(saved!));
    }
  }, []);

  const handleDisableRtmClick = () => {
    setExerciseNotCreated(false); // close exercise not created modal
    setRemoteTherapeuticMonitoring(true); // open disable RTM modal
  };

  // useEffect(() => {
  //   const stored = localStorage.getItem("exercisePlan");
  //   if (stored === "true") {
  //     setExcercisePlan(true);
  //   }
  //   else{
  //     setShowSuccessModal(true);
  //   }
  // }, []);

  useEffect(() => {
    const checkPopup = () => {
      const stored = localStorage.getItem("showRtmPopup");
      if (stored === "true") {
        setExerciseNotCreated(true);
        localStorage.removeItem("showRtmPopup");
      }
    };

    // run once on mount
    checkPopup();

    // listen for custom event we dispatch
    window.addEventListener("showRtmPopup", checkPopup);

    return () => window.removeEventListener("showRtmPopup", checkPopup);
  }, []);

  // useEffect(() => {
  //   const stored = localStorage.getItem("exercisePlan");
  //   if (stored === "true") {
  //     setExcercisePlan(true);
  //   }
  //   else{
  //     setShowSuccessModal(true);
  //   }
  // }, []);

  let location =
    window.location.href == window.location.origin + "/full-visit-summary"
      ? true
      : false;

  async function GetAllExercises() {
    let loc =
      window.location.href == window.location.origin + "/review-exercises"
        ? true
        : false;

    if (!loc) {
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        return;
      }

      try {
        await GetRecommendedExercises({
          patientId: +localStorage.getItem("patientServerID")!,
          CurrentVisitDateString: localDateTime(),
        })
          .then(async function (response: any) {
            setIsLoading(false);
            debugger;
            console.log("rtmEnabledRef.current", rtmEnabledRef.current);
            if (rtmEnabledRef.current) {
              let isPlanAssigned =
                response?.data?.exercisesRecommendationHistory ?? [];
              if (isPlanAssigned.length > 0) {
                let latestPlan = isPlanAssigned[0];
                if (latestPlan?.isPlanValid && latestPlan.totalExercises >= 2) {
                  localStorage.setItem("exercisePlan", "true");
                } else {
                  localStorage.setItem("exercisePlan", "false");
                }
              }
            }

            // Clone the array to avoid mutating state directly
            // const clonedArr: any = [...response.data.allExercisesList];

            // take out the ids from previousExercise
            // let selectedIds = reviewExercises?.exercises?.map(
            //   (exercise: any) => exercise.testExercises[0].id
            // );

            // const sortArr = sortTests(clonedArr, selectedIds);

            setAllExercisesState((prevState: any) => ({
              ...prevState,
              exercises: response.data.allExercisesList,
              // exercises:
              //   reviewExercises?.exercises.length > 0
              //     ? sortArr
              //     : response.data.allExercisesList,
              exercisesRecommendationHistory:
                response.data.exercisesRecommendationHistory,
              recommendedExercisesBasedOnAssessment:
                response.data.recommendedTestsList,
              sidesLookup: response.data.sidesLookup,
              patientDetails: response.data.patientDetails,
              previouslySelectedExercises: response.data.previousExercisesList,
              // previouslySelectedExercises:
              //   reviewExercises?.exercises.length > 0
              //     ? reviewExercises?.exercises
              //     : response.data.previousExercisesList,
            }));
            setFixedExercisesCount((prevState: any) => ({
              ...prevState,
              exercises: response.data.allExercisesList,
              // exercises:
              //   reviewExercises?.exercises.length > 0
              //     ? sortArr
              //     : response.data.allExercisesList,
              exercisesRecommendationHistory:
                response.data.exercisesRecommendationHistory,
              recommendedExercisesBasedOnAssessment:
                response.data.recommendedTestsList,
              sidesLookup: response.data.sidesLookup,
              patientDetails: response.data.patientDetails,
              previouslySelectedExercises: response.data.previousExercisesList,
              // previouslySelectedExercises:
              //   reviewExercises?.exercises.length > 0
              //     ? reviewExercises?.exercises
              //     : response.data.previousExercisesList,
            }));
            setPreviousExercises(response?.data?.previousExercisesList);
            // setPreviousExercises(
            //   reviewExercises?.exercises.length > 0
            //     ? reviewExercises?.exercises
            //     : response.data.previousExercisesList
            // );
          })
          .catch((error) => {
            setIsLoading(false);
            history.push("/confirmation", {
              actionType: ActionType.FailureAPIResponse,
            });
            console.error(error);
          });
      } catch (error) {
        setIsLoading(false);
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
        console.error(error);
      }
    }
  }

  const HideShowFooter = async (hideShow: boolean) => {
    showButtonsFooter(hideShow);
  };

  useEffect(() => {
    setIsLoading(true);
    GetAllExercises();
    const rtmEnabled = localStorage.getItem("isRtmEnabled") === "true";
    setIsRtmConfigurationEnabled(rtmEnabled);
    rtmEnabledRef.current = rtmEnabled;
    // // update local state
    // setPatientDetails((prev) => ({
    //   ...prev,
    //   isPatientRTMEnabled: rtmEnabledRef.current,
    // }));

    // // and update Recoil state as well
    // setPatientDetailsRecoil((prev) => ({
    //   ...prev,
    //   isPatientRTMEnabled: rtmEnabledRef.current,
    // }));
  }, [location]);

  useEffect(() => {
    setIsDuplicateCalled(false);
  }, []);

  // Clear error message after 5 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const UpdateSelectedExercises = () => {
    let selectedExercises: number[] = [];
    previousExercises?.map((exercise: any) => {
      selectedExercises.push(exercise.testExercises[0].id);
    });
    console.log("Ids extracted from previous exercises", selectedExercises);
    return selectedExercises;
  };

  console.log("previousExercises", previousExercises);

  const enableDisablePatientRtm = async (
    isNewEpisode: boolean,
    isRtmReenable: boolean,
  ) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await EnableDisablePatientRtm({
        PatientId: localStorage.getItem("patientServerID"),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
        IsPatientRTMEnabled: !patientDetails?.isPatientRTMEnabled,
        LocalDateTime: localDateTime(),
        IsNewEpisode: isNewEpisode,
        IsRtmReenable: isRtmReenable,
        MasterUserId: JSON.parse(localStorage.getItem("patientMasterID")!),
        MobilePhone: localStorage.getItem("patientMobileNumber") ?? "",
      }).then(async function (response: any) {
        console.log("Response: ", response);
        if (response?.data?.dbResponse?.id > 0) {
          let status;
          if (!patientDetails?.isPatientRTMEnabled) {
            status = "true";
          } else {
            status = "false";
          }
          sessionStorage.setItem("isPatientRtmTrue", status);
          sessionStorage.setItem(
            "patientDetails",
            JSON.stringify(patientDetails),
          );
          handleEducationClose();
        }
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const handleRtmToggle = async () => {
    console.log(
      "patientDetails?.isPatientRTMEnabled",
      patientDetails?.isPatientRTMEnabled,
    );
    if (patientDetails?.isPatientRTMEnabled) {
      setRemoteTherapeuticMonitoring(true);
    } else {
      if (patientDetails?.isRtmEverEnabled) {
        setIsRtmReenable(true);
        setChooseEpisode(true);
        //await enableDisablePatientRtm();
      } else {
        setIsRtmReenable(false);
        setConsentForm(true);
      }
    }
  };

  const handleConsentClose = async () => {
    setConsentForm(false);
    await enableDisablePatientRtm(true, false);
    const isSFTPPatient =
      localStorage.getItem("isSFTPPatient") === "true" ? true : false;
    if (isSFTPPatient || true) {
      handleEducationClose();
    } else {
      setCompletedEducation(true);
    }
  };

  const handleConsentFormObject = (data: any) => {
    console.log("Received from ConsentFormModal:", data);
    setIsNewEpisode(true);
    setConsentFormData(data);
    setConsentForm(false);
    setSetupEpisode(true);
    // Open the SetupEpisode modal immediately
  };

  const handleSetupEpisodeClose = async () => {
    await enableDisablePatientRtm(true, false);
    handleEducationClose();
  };

  const handleChooseEpisodeClose = async () => {
    setIsNewEpisode(false);
    setChooseEpisode(false);
    await enableDisablePatientRtm(false, true);
    handleEducationClose();
  };

  const handleNewEpisodeClose = async () => {
    setIsNewEpisode(true);
    setNewEpisode(false);
    await enableDisablePatientRtm(true, true);
    handleEducationClose();
  };

  const handleEducationClose = () => {
    setCompletedEducation(false);
    setRtmEnabled(true);
    setOpenRtmModal(true);
  };

  const handleDisableConsentClose = () => {
    setRemoteTherapeuticMonitoring(false);
    setRtmEnabled(false);
    setOpenRtmModal(true);
  };

  const handleEnableDisableModalClose = (isEnabled: boolean) => {
    setOpenRtmModal(false);
    if (!isEnabled) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
    } else {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
      history.push("/full-visit-summary", {
        patientInfo: patientDetails,
      });
    }
  };

  const handleSkipModule = () => {
    setExerciseNotCreated(false); // close the modal
    localStorage.removeItem("exercisePlan");
    history.push("/patient-page"); // navigate away from this module
  };

  const handleSkipExercisePlan = (isEnabled: boolean) => {
    console.log("Skip clicked");
    if (!isEnabled) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
    } else {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
    }
    setOpenRtmModal(false);
    setOpenProactiveAfterClose(true); // ONLY set when skip is clicked
    localStorage.removeItem("exercisePlan");
  };

  const handleRegisterPatient = () => {
    debugger;
    console.log("Register Patient clicked");
    setProactiveYouModal(false);
    setRegisterPatientModal(true);
  };

  const handleCloseRegistrationModal = async () => {
    setRegisterPatientModal(false);

    // Refresh patient details to get updated RTM status
    // await GetPatientVisitDetails();
  };

  return (
    <>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={RemoteTherapeuticMonitoring}
        placeholder={undefined}
      >
        <RemoteTherapeuticMonitoringModal
          setRemoteTherapeuticMonitoring={setRemoteTherapeuticMonitoring}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          onClose={handleDisableConsentClose}
        ></RemoteTherapeuticMonitoringModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={openRtmModal}
        placeholder={undefined}
        onDidDismiss={() => {
          if (openProactiveAfterClose) {
            console.log("Opening ProactiveYou modal now...");
            setProactiveYouModal(true);
            setOpenProactiveAfterClose(false); // reset flag
          }
        }}
      >
        <RtmEnabledModal
          enabled={RtmEnabled}
          onClose={handleEnableDisableModalClose}
          onSkip={handleSkipExercisePlan}
        ></RtmEnabledModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={registerPatientModal}
        placeholder={undefined}
      >
        <PatientRegistrationQRModal
          setRegisterPatientModal={handleCloseRegistrationModal}
          patientData={{
            masterPatientId: Number(localStorage.getItem("masterUserId")) || 0,
            email: patientDetailsRecoil?.email,
            mobilePhone: patientDetailsRecoil?.mobilePhone,
            firstName: patientDetails?.firstName,
            lastName: patientDetails?.lastName,
            fullName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            patientName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            dob: patientDetails?.dob,
            DOB: patientDetails?.dob,
            FirstName: patientDetails?.firstName,
            LastName: patientDetails?.lastName,
            PatientLocationId: patientDetails?.patientLocationId,
          }}
          isCalledAfterRtmEnabled={true}
          onError={(message) => {
            setErrorMessage(message);
          }}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={proactiveYouModal}
        placeholder={undefined}
      >
        <ProactiveYouModal
          HideProactiveModal={setProactiveYouModal}
          onRegisterPatient={handleRegisterPatient}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={CompletedEducation}
        placeholder={undefined}
      >
        <CompletedEducationModal
          setCompletedEducation={setCompletedEducation}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          onClose={handleEducationClose}
        ></CompletedEducationModal>
      </IonModal>

      <IonModal
        backdropDismiss={false}
        className="consent-form-modal-wrap"
        isOpen={ConsentForm}
        placeholder={undefined}
      >
        <ConsentFormModal
          setConsentForm={setConsentForm}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          phoneNumber={patientDetails?.mobilePhone ?? ""}
          email={patientDetails?.email ?? ""}
          onClose={handleConsentClose}
          consentFormObjectPassToParent={handleConsentFormObject}
        ></ConsentFormModal>
      </IonModal>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={SetupEpisode}
        placeholder={undefined}
      >
        <SetupEpisodeModal
          setSetupEpisode={setSetupEpisode}
          consentFormData={consentFormData}
          onClose={handleSetupEpisodeClose}
          rtmStartDate={
            consentFormData?.StartDate
              ? new Date(consentFormData.StartDate).toLocaleDateString("en-US")
              : undefined
          }
        ></SetupEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={NewEpisode}
        placeholder={undefined}
      >
        <NewEpisodeModal
          setNewEpisode={setNewEpisode}
          onClose={handleNewEpisodeClose}
          rtmStartDate={
            patientDetails?.rtmStartDate
              ? format(new Date(patientDetails.rtmStartDate), "MM/dd/yyyy")
              : undefined
          }
        ></NewEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        onDidDismiss={() => setChooseEpisode(false)}
        isOpen={ChooseEpisode}
        placeholder={undefined}
      >
        <ChooseEpisodeModal
          setChooseEpisode={setChooseEpisode}
          setNewEpisode={setNewEpisode}
          onClose={handleChooseEpisodeClose}
          isOpen={ChooseEpisode}
          rtmStartDate={
            patientDetails?.rtmStartDate
              ? format(new Date(patientDetails.rtmStartDate), "MM/dd/yyyy")
              : undefined
          }
        ></ChooseEpisodeModal>
      </IonModal>

      {/* {!isLoading ? ( */}
      <IonPage placeholder={undefined} className="page">
        <TopLeftUserName
          headerText={
            rtmEnabledRef.current && patientDetails?.isPatientRTMEnabled
              ? "ExercisePlan"
              : ""
          }
        ></TopLeftUserName>

        {!isLoading ? (
          <IonContent
            scroll-y="true"
            placeholder={undefined}
            className="full-visit-summary-main-page slide-in-right"
          >
            <IonGrid
              className="container full-visit-summary-page"
              placeholder={undefined}
            >
              {errorMessage && <ErrorTopToaster errorString={errorMessage} />}
              {rtmEnabledRef.current && (
                <div className="remote-therapeutic-card mb-24">
                  <div className="rtm-wrap d-flex justify-content-between ">
                    <div className="d-flex align-items-center gap-10">
                      <IonLabel
                        className="label mb-0 fz-20 fw-400 text-black"
                        placeholder={undefined}
                      >
                        Remote Therapeutic Monitoring
                      </IonLabel>

                      <div
                        className={`rtm-checkbox-wrap ${
                          patientDetails?.isPatientRTMEnabled
                            ? "enabled"
                            : "disabled"
                        }`}
                      >
                        {patientDetails?.isPatientRTMEnabled
                          ? "Enabled"
                          : "Disabled"}
                      </div>
                    </div>

                    {(!patientDetails?.isSFTPEhrImportEnabled ||
                      patientDetails?.externalPatientId !== 0) && (
                      <IonButton
                        placeholder={undefined}
                        className="generic-btn-outline mb-0"
                        onClick={() => {
                          handleRtmToggle();
                        }}
                      >
                        {patientDetails?.isPatientRTMEnabled
                          ? "Disable RTM"
                          : "Enable RTM"}
                      </IonButton>
                    )}
                  </div>
                </div>
              )}
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="heading-sec">
                    <h3>Previous Exercises</h3>
                    {allExercises.exercisesRecommendationHistory != null ? (
                      <ExerciseSlider
                        assesements={
                          allExercises.exercisesRecommendationHistory
                        }
                      ></ExerciseSlider>
                    ) : (
                      <p>No exercises assigned yet.</p>
                    )}
                  </div>
                </IonCol>
              </IonRow>
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <ExerciseCard
                    exercisesList={fixedExercisesCount}
                    hideShowFooter={HideShowFooter}
                    selectedExercisesid={UpdateSelectedExercises()}
                    previousExercises={previousExercises}
                    isDuplicatePlanCalled={true}
                    onCountChange={setExeCount}
                    isRTMEnabled={patientDetails?.isPatientRTMEnabled}
                  ></ExerciseCard>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
        ) : (
          <Loader />
        )}
        {!isLoading && (previousExercises?.length > 0 || buttonsFooter) && (
          <IonFooter
            className="ion-no-border duplicate-ex-page-footer"
            placeholder={undefined}
          >
            <IonGrid className="container" placeholder={undefined}>
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="two-col-btn">
                    <IonButton
                      placeholder={undefined}
                      className="blue-outline-btn"
                      onClick={() => {
                        // const isRtmEnabled =
                        //   patientDetails?.isPatientRTMEnabled;
                        // const hasExercisePlan =
                        //   localStorage.getItem("exercisePlan") === "true";

                        // if (isRtmEnabled && !hasExercisePlan) {
                        //   // show RTM popup
                        //   localStorage.setItem("showRtmPopup", "true");
                        //   window.dispatchEvent(new Event("showRtmPopup"));
                        // } else {
                        //   // normal navigation
                        //   localStorage.removeItem("exercisePlan");
                        // }
                        history.push("/patient-page");
                      }}
                    >
                      Cancel
                    </IonButton>
                    <IonButton
                      placeholder={undefined}
                      className="blue-btn"
                      disabled={
                        rtmEnabledRef.current &&
                        patientDetails?.isPatientRTMEnabled
                          ? exeCount < 2
                          : false
                      }
                      onClick={() => {
                        if (
                          rtmEnabledRef.current &&
                          patientDetails?.isPatientRTMEnabled
                        ) {
                          exeCount >= 2 && history.replace("/review-exercises");
                        } else {
                          history.replace("/review-exercises");
                        }
                      }}
                    >
                      Next
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonFooter>
        )}
      </IonPage>
      {/* ) : (
        <Loader />
      )} */}
    </>
  );
};
export default FullVisitSummary;
